module.exports = __webpack_public_path__ + "checker-board.png?3034bf7b44ffc0d6c9b6ecf517974250";